import { QueryClient } from '@tanstack/react-query'

/**
 * Zentrale Datenschicht des Clients. Ab Stufe 2 laufen alle Supabase-Abfragen
 * (Equipment, Bohnen, Brews, Feed) hierüber — dadurch entfällt Datenladen in
 * useEffect samt der daraus folgenden Render-Kaskaden und manuellen Ladezustände.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
